"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, _react.default.createElement("path", {
  d: "M7.05 9.7a.5.5 0 10.58-.81 3.25 3.25 0 01-.32-5.04l2.13-1.97a3.32 3.32 0 014.67.16 3.25 3.25 0 01-.16 4.62l-2.12 1.97a.5.5 0 10.68.73l2.12-1.96a4.25 4.25 0 00.21-6.04 4.32 4.32 0 00-6.08-.21L6.64 3.12a4.25 4.25 0 00.41 6.58zm1.9-3.4a.5.5 0 00-.58.81 3.25 3.25 0 01.32 5.04l-2.13 1.97a3.32 3.32 0 01-4.67-.16 3.25 3.25 0 01.16-4.62l2.12-1.97a.5.5 0 00-.68-.73L1.37 8.6a4.25 4.25 0 00-.21 6.04 4.32 4.32 0 006.08.21l2.12-1.97a4.25 4.25 0 00-.41-6.58z"
}));

exports.default = _default;